module.exports = __webpack_public_path__ + "img/edc-mandiri.0549fc20.png";